import type { StylePart } from '@/features/map';

/**
 * Marks where the wind goes in the layer order. Its layers draw on canvas sources, which can only be added
 * at runtime (see WindLayer), right above this placeholder.
 */
export const WIND_ANCHOR = 'wind-anchor';
export const WIND_GRADIENT = 'wind-gradient';
export const WIND_PARTICLES = 'wind-particles';

export const forecastStyle = (): StylePart => ({
  layers: [{ id: WIND_ANCHOR, type: 'background', layout: { visibility: 'none' } }],
});
